<template>
    <section :class="[namespace(), skinStyle, cls]" ref="container">
        <select ref="select" :size="size" :class="classes" :disabled="disabled">
            <slot />
        </select>
    </section>
</template>

<script>
import $ from 'jquery';
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-combo-box',
    mixins: [mixins],
    props: {
        dataModel: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'medium',
            validator(val) {
                return utils.inArray(['small', 'medium', 'large'], val) >= 0;
            }
        },
        width: {
            type: Number,
            default: 100
        }
    },
    watch: {
        dataModel() {
            this.render();
        }
    },
    computed: {
        cls() {
            return this.namespace(`__${utils.getSkinSuffix(this.skin)}`);
        },
        sizeClass() {
            if (this.size === 'medium') {
                return '';
            } else {
                return this.mdsNS(`combo-box--${this.size}`);
            }
        },
        classes() {
            if (this.size === 'medium') {
                return '';
            }
            return `${this.mdsNS('combo-box--default')} ${this.sizeClass}`;
        },
        select2Options() {
            return utils.extend(
                {
                    width: this.width
                },
                {
                    data: this.dataModel,
                    dropdownParent: $(this.$refs.container)
                },
                {
                    theme: `default ${this.mdsNS('combo-box')}  ${
                        this.sizeClass
                    }`,
                    containerCssClass: `${this.mdsNS(
                        'combo-box__container'
                    )} ${this.namespace('__container')}`,
                    dropdownCssClass: this.mdsNS('combo-box__dropdown')
                }
            );
        }
    },
    mounted() {
        this.$$selectEl = $(this.$refs.select);
        this.$$selectEl
            .select2(this.select2Options)
            .on('select2:select', e => {
                this.$emit('change', e.params.data.id);
            })
            .on('select2:open', e => {
                e.stopPropagation();
                $(document.body)
                    .find('.select2-container--open')
                    .removeClass(
                        this.mdsNS('container--black container--dark-gray')
                    )
                    .addClass(this.skinStyle);
            });
    },
    beforeCreate() {
        if (!$) {
            throw new Error('Missing jQuery dependency');
        }
    },
    created() {
        this.namespace = utils.namespace('ui-combo-box', false);
    },
    destroyed() {
        this.$$selectEl.off().select2('destroy');
    },
    methods: {
        render() {
            this.$$selectEl
                .select2('destroy')
                .empty()
                .select2(this.select2Options);
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-combo-box';
@import '../../mds/constants';
.#{$namespace} {
    &__container,
    .select2-results__option {
        font-size: $mds-font-size-s;
    }
    .select2-container .select2-selection--single {
        border: 0;
        border-radius: 0;
        height: 100%;
        background-color: #e5e5e5;
        .select2-selection__rendered {
            color: $mds-text-color-primary-on-light;
            line-height: normal;
            padding: 0;
        }
        .select2-selection__arrow {
            right: 0;
            top: 0;
            width: 21px;
        }
    }
    &__dark-gray {
        .select2-container .select2-selection--single {
            background-color: #333;
            .select2-selection__rendered {
                color: $mds-text-color-primary-on-dark;
            }
        }
    }
}
</style>
